import React from 'react';
import PropTypes from 'prop-types';
import { MessageList } from './MessageList';
import { SendMessageForm } from './SendMessageForm'
import { Loader } from '../../../../../common/elements';

export const ConversationPane = (props) => {

	const { conversation, postMessage } = props;
	const person_id = localStorage.getItem('person_id');

	if (!conversation) {
		return <Loader />;
	}

	if (conversation) return (
		<div className="msg-pane">
			<div className="row">
				{
					conversation.participants.filter((participant) => participant.id !== parseInt(person_id, 10)).map((participant, index) =>
						<div className="col-xs-12 col-md-6" key={index}>
							<img
								className="img-circle margin-right"
								src="https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342"
								alt="Member img"
								height="48"
							/>
							<strong key={index}>{participant.first_name} {participant.last_name}</strong>
						</div>
					)
				}
			</div>
			<hr className="hr-tour" />
			<div className="convo-pane messageList">
				<MessageList messages={conversation.messages} />
			</div>
			<hr className="hr-tour" />
			<SendMessageForm onSubmit={postMessage} />
		</div>
	);
};

ConversationPane.propTypes = {
	conversation: PropTypes.object,
	postMessage: PropTypes.func
}



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/ConversationPane.js